import React, { useEffect, useState } from 'react';
import { useLoginIdValue } from '@/hooks/tab';
import { useClientId } from '@/hooks/client';
import { useCurrentLoginIdItem } from '@/hooks/reference';
import { ClientTab } from '@/types/common';
import { ClientView } from '@/components/organisms/sidebar/Common';

const View: React.FC = () => {
  const [clientTab, setClientTab] = useState(ClientTab.BOUGHT);
  const [tabs, setTabs] = useState([clientTab]);
  const [inputValue] = useLoginIdValue();
  const [currentItem, setCurrentItem] = useCurrentLoginIdItem();
  const data = useClientId(Number(inputValue));

  useEffect(() => {
    if (!tabs.includes(clientTab)) {
      setTabs([...tabs, clientTab]);
    }
  }, [clientTab]);

  return (
    <ClientView
      isEmailTab={false}
      isPhoneTab={false}
      inputValue={`#${inputValue}`}
      clientTab={clientTab}
      clientTabs={tabs}
      setClientTab={setClientTab}
      setCurrentItem={setCurrentItem}
      currentItem={currentItem}
      data={data}
    />
  );
};

export default View;
